import React,{useEffect,useState} from 'react';
import {
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Select,
    Box,
    Flex,Image,
    Text,Button,Card,CardBody,SimpleGrid,
    Textarea,Checkbox, CheckboxGroup,useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    
  } from "@chakra-ui/react";
  import { IoMdClose } from "react-icons/io";
  import { useBillItems } from '../context/tableItemsContext';
import axios from 'axios'
import toast from 'react-hot-toast';

  const FullBottleModal=({onOpen,isOpen,onClose,data,isAc,tableNo,isHappyHour,happyDiscount,priceAdd,prcieAddDiscount})=>{
    console.log('priceAddfull',priceAdd)
    console.log('prcieAddDiscountfull',prcieAddDiscount)
    const [printData,setPrintData]=useState([])
    const [formData, setFormData] = useState({
        name: "",
       
        price:0
    })

    const customerId=localStorage.getItem('customerId')
    const {  addToBill, updateQuantity, deleteItem, clearBill } = useBillItems();
    console.log(data)
    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value,
        });
      };
      const isHalf=false;
      const isBottle =true
      const handleAddToBill = (item) => {
        // Check if the item already exists in the bill
       addToBill(customerId,item,isAc,isHalf,tableNo,isBottle,isHappyHour,happyDiscount,priceAdd,prcieAddDiscount);
      };
       
      useEffect(()=>{
        if(data){
            setFormData({
                name:data.name,
                 price:isAc === true ? data.purchaseRate : data.purchaseRate 
            })
        }
      },[data])
      

     

    return (
        <Modal isOpen={isOpen} onClose={onClose} width='full' size='md'   >
      <ModalOverlay />
      <ModalContent bg='#f9f1e3'>
        <ModalHeader display='flex' justifyContent='space-between' alignItems='center'>
            <Text>Full Bottle </Text>
            <Button colorScheme='red' onClick={onClose} ><IoMdClose/></Button></ModalHeader>
       
        <ModalBody >
           <FormControl>
            <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' gap={2}>
            <FormLabel>Name</FormLabel>
            <Input w='80%' bg='white' name='name' placeholder='Enter Category Name' value={formData.name+" bottle"} onChange={handleInputChange} />
            </Box>
          
            <Box gap={2} display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
            <FormLabel>Price</FormLabel>
            <Input w='80%' bg='white' name='price' placeholder='Enter Price' value={formData.price} onChange={handleInputChange} />
            </Box>
            <Box display='flex' justifyContent='center' alignItems='center' mt={3}>
            <Button colorScheme='blue' size='sm' onClick={()=>handleAddToBill(data)}> Add</Button>
            </Box>
           </FormControl>
        </ModalBody>
        <ModalFooter>
         
         </ModalFooter>
       </ModalContent>
     </Modal>
    )
  }
  export default FullBottleModal